<template>
  <ValidationProvider
    tag="tr"
    :vid="vid"
    :mode="veeMode || defaultVeeMode"
    :rules="veeRules"
    :debounce="veeDebounce"
    v-slot="{ classes, valid, invalid, errors, validate }"
  >
    <th scope="row" width="25%">{{ label }}</th>
    <td width="10%">
      <span class="bg-red" v-show="isRequired">必須</span>
    </td>
    <td class="form-inline no-margin-top">
      <slot name="beforeInput" :classes="classes" :invalid="invalid" :errors="errors" :valid="valid" />
      <input
        v-bind="$attrs"
        :class="buildClasses(classes)"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
      <slot
        name="afterInput"
        :classes="classes"
        :invalid="invalid"
        :errors="errors"
        :valid="valid"
        :validate="validate"
      />
      <slot name="feedback" :classes="classes" :invalid="invalid" :errors="errors" :valid="valid">
        <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
      </slot>
    </td>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import uniq from 'lodash/uniq';
import sortBy from 'lodash/sortBy';

export default {
  inheritAttrs: false,
  props: {
    vid: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: 'col-lg-8',
    },
    label: {
      type: String,
      default: '',
    },
    baseRule: {
      type: String,
      default: '',
    },
    extraRules: {
      type: String,
      default: '',
    },
    veeMode: {
      type: String,
      default: null,
    },
    veeDebounce: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ValidationProvider,
  },
  methods: {
    buildClasses(veeClasses) {
      let veeClassesActive = Object.keys(veeClasses).filter((key) => veeClasses[key]);

      // Only add class is-valid or is-invalid for no required field when input has value
      veeClassesActive = this.isRequired || (this.value && veeClasses.validated) ? veeClassesActive : {};

      return ['form-control', this.inputClass].concat(Object.values(veeClassesActive)).join(' ');
    },
  },
  computed: {
    isRequired() {
      return this.extraRules.includes('required');
    },
    rules() {
      return this.extraRules.split('|');
    },
    veeRules() {
      let rules = [this.baseRule].concat(this.rules);

      // re-order rule required to first
      rules = uniq(
        sortBy(rules, [
          function (o) {
            return o.indexOf('required') >= 0 ? 0 : 1;
          },
        ])
      );

      // re-order rule validation by server side to last
      rules = uniq(
        sortBy(rules, [
          function (o) {
            return o.indexOf('_id_unique') >= 0 ? 1 : 0;
          },
        ])
      );

      return rules.join('|');
    },
    defaultVeeMode() {
      return this.isRequired ? 'eager' : 'aggressive';
    },
  },
};
</script>
